import { PureComponent } from 'preact-compat'

import { IdeaStatus } from './interfaces'

export interface TopicPillsProps {
  trashed: boolean
  spam: boolean
  pending: boolean
  sticky?: boolean
  publicLabel?: string | null
  ideationStatus?: IdeaStatus
  isAuthor?: boolean
  hasBestAnswer?: boolean
  reported: boolean
  isQuestion?: boolean
}

class TopicPills extends PureComponent<TopicPillsProps> {
  render() {
    const { trashed, spam, ideationStatus, publicLabel, pending, isAuthor, sticky, hasBestAnswer, reported, isQuestion } = this.props
    return (
      <div className='pill-container'>
        {isQuestion && <span className='pill pill--question'>question</span>}
        {trashed && <span className='pill pill--trashed'>trashed</span>}
        {pending && <span className='pill pill--pending'>pending</span>}
        {ideationStatus && (
          <span
            className='idea-status-pill'
            style={{
              color: `#${ideationStatus.textColor}`,
              backgroundColor: `#${ideationStatus.backgroundColor}`
            }}
          >
            {ideationStatus.name}
          </span>
        )}
        {sticky && <span className='pill pill--sticky'>sticky</span>}
        {publicLabel && <span className='pill pill-article-label'>{publicLabel}</span>}
        {spam && <span className='pill pill--spam'>spam</span>}
        {reported && <span className='pill pill--reported'>reported</span>}
        {isAuthor && <span className='pill pill--author'>author</span>}
        {hasBestAnswer && <span className='pill pill--solved'>solved</span>}
      </div>
    )
  }
}

export default TopicPills
